import { RenderFn, EffectPreview } from './ScenePreview';

export default (wipeDuration: number) => {
  /* polygon object which we move along the canvas to gradually clip the frame */
  const drawClipPolygon = (ctx: CanvasRenderingContext2D, k: number) => {
    const h = ctx.canvas.height;
    const w = ctx.canvas.width;
    const a = (h * h) / w;
    // polygon which will move along the frame and clip
    const polygon = {
      a: { x: w + a, y: h },
      b: { x: w, y: 0 },
      c: { x: w - a, y: -h },
      d: { x: a, y: 2 * h },
      e: { x: -a, y: 0 }
    };
    const W = w * k;
    const H = h * k;

    const region = new Path2D();
    region.moveTo(polygon.b.x - W, polygon.b.y + H);

    region.lineTo(polygon.c.x - W, polygon.c.y + H);
    region.lineTo(polygon.e.x - W, polygon.e.y + H);
    region.lineTo(polygon.d.x - W, polygon.d.y + H);
    region.lineTo(polygon.a.x - W, polygon.a.y + H);
    region.lineTo(polygon.b.x - W, polygon.b.y + H);
    region.closePath();

    ctx.clip(region);
  };

  const beforeFrameDrawn: RenderFn = (ctx, preview) => {
    const relativeTime =
      preview.time - preview.settings.trimStart - (preview.settings.duration - wipeDuration);
    const k = relativeTime / wipeDuration;

    if (relativeTime >= 0) {
      ctx.save();
      drawClipPolygon(ctx, k);
    }
  };

  const afterFrameDrawn: RenderFn = ctx => {
    ctx.restore();
  };

  const effectPreview: EffectPreview = { beforeFrameDrawn, afterFrameDrawn };

  return effectPreview;
};
